import React from 'react';
import { useSelector } from 'react-redux';

import useBreedDescriptionModal from 'dpl/breeder_search_results/hooks/useBreedDescriptionModal';

const COMMON_CLASSNAMES = 'di fw-medium ml1 underline';

export default function BreedDescription() {
  const { breedDescription, breedOverviewPageUrl } = useSelector(
    state => state.server
  );
  const { openModal } = useBreedDescriptionModal();

  return (
    <div className="BreederSearchResultsBreedDescription f2 f3-sm">
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: breedDescription }}
        className="BreederSearchResultsBreedDescription__innerHtml di"
      />
      {breedOverviewPageUrl ? (
        <a
          href={breedOverviewPageUrl}
          target="_blank"
          rel="noreferrer"
          data-test-id="breed_overview_learn_more_link"
          className={COMMON_CLASSNAMES}
        >
          Learn more
        </a>
      ) : (
        <button
          type="button"
          onClick={openModal}
          data-test-id="breed_description_learn_more_button"
          className={COMMON_CLASSNAMES}
        >
          Learn more
        </button>
      )}
    </div>
  );
}
